import React from 'react';
import { oneOf, any } from 'prop-types';
import './Button.scss';
import bem from '../../utils/bem';

export const TYPE = {
  naked: 'naked',
  red: 'red',
};

export const SIZE = {
  medium: 'medium',
  normal: 'normal',
};

export const UI = {
  normal: 'normal',
  circular: 'circular',
};

const Button = ({
  component: Component,
  children,
  type,
  textSize,
  padding,
  ui,
  submit,
  button = '',
  className = '',
  newStyle,
  supernaked,
  black,
  uppercase,
  gold,
  green,
  redBorderText,
  videoCall,
  ...props
}) => (
  <Component
    {...props}
    className={`${className} ` + bem(`veinsa-button`, {
      [type]: type,
      [`text-${textSize}`]: textSize,
      [`padding-${padding}`]: padding,
      [`ui-${ui}`]: ui,
      disabled: props.disabled,
      'new-style': newStyle,
      'supernaked': supernaked,
      'black': black,
      'uppercase': uppercase,
      green,
      gold,
      redBorderText,
      videoCall,
    })}
    type={(submit && 'submit') || button}
  >
    {children}
  </Component>
);

Button.propTypes = {
  component: any,
  padding: oneOf(Object.keys(SIZE)),
  type: oneOf(Object.keys(TYPE)),
  textSize: oneOf(Object.keys(SIZE)),
  ui: oneOf(Object.keys(UI)),
};

Button.defaultProps = {
  type: TYPE.naked,
  textSize: SIZE.normal,
  padding: SIZE.normal,
  ui: UI.normal,
  component: 'button',
};

export default Button;
